import { tool } from "ai";
import { z } from "zod";
import { PROXY_URL, getTodayDate } from "./shared";

export default tool({
  description:
    "Retrieves sales actuals for one single country only. If user required insights in multiple countries, this tool should be used multiple times. The quantity values for sales data.",
  parameters: z.object({
    from: z
      .string()
      .describe("Start date in YYYY-MM-DD format")
      .default("2024-01-01"),
    to: z
      .string()
      .describe("Ending date in YYYY-MM-DD format")
      .default(getTodayDate()),
    channel: z
      .enum(["Remote", "Online", "Store", ""])
      .describe(
        "Sales channel. If the user has not specified any sales channel then it is omitted"
      )
      .optional(),
    country: z.string().describe("Two letter country code.").default("NL"),
    timeframe: z.enum(["year", "month", "week", ""]).default("year"),
    hfb_no: z.string().optional(),
  }),
  execute: async (params) => {
    const { country, timeframe, from, to, hfb_no, channel } = params;

    const searchParams = new URLSearchParams({
      from,
      to,
      timeframe,
      identifier: `country.eq('${country}')`,
      select: `country,created_net_revenue.sum()${
        channel ? `,sales_channel` : ""
      }`,
      omit: "filters",
      filter: hfb_no ? `hfb_no.eq('${hfb_no}')` : "",
    }).toString();
    const url = `${PROXY_URL}/ts-sales-actuals-api/v1/sales?${searchParams}`;
    const results = await fetch(url);
    const json = await results.json();
    return json;
  },
});
